import * as React from 'react';
import { times } from 'lodash';
import { SkeletonImage } from 'src/share/components/SkeletonImage/SkeletonImage';

const getHostname = (url) => {
  return url ? url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1] : "www.foo.com";
};

export const PimEyes = (images, removeInvalidImage) => (
  images.map((element, index) => (
    <figure key={index} className="similar-card">
      <img
        className="similar-card--image"
        src={element.imageUrl}
        onClick={() => window.open(element.page)}
        onError={removeInvalidImage}
      />
      <div className="similar-card--text similar-card--info" onClick={() => window.open(element.page)}>
        <div>
          <img src={element.face} /> = {element.similarity}%
        </div>
        <span>{getHostname(element.page)}</span>
      </div>
    </figure>
  ))
);

export const TinEyeSearch = (images, removeInvalidImage, isFetchingData) => (
  [...images, ...isFetchingData ? times(1, i => ({
    imageUrl: "loading",
    page: ""
  })) : []].reduce((elements, element, index) => {
    if (element.imageUrl !== "loading") {
      const figure = (
        <figure key={`Figure-${index}`} className="similar-card">
          <img className="similar-card--image" src={element.imageUrl} onClick={() => window.open(element.page)} onError={removeInvalidImage} />
          <div className="similar-card--text" onClick={() => window.open(element.page)}>
            <span>{getHostname(element.page)}</span>
          </div>
        </figure>);
      elements.push(figure);
    } else {
      elements.push(<div key={'hola'} className="skeleton-transition" />);
      const skeleton = times(50, i => <SkeletonImage key={i} index={i} />);
      elements = [...elements, ...skeleton];
    }
    return elements;
  }, [] as any)
);

export const BingSearch = (images) => (
  images.map((element, index) => (
    <figure key={index} className="similar-card">
      <img className="similar-card--image" src={element.imageUrl} onClick={() => window.open(element.page)} />
      <div className="similar-card--text" onClick={() => window.open(element.page)}>
        <span>{getHostname(element.page)}</span>
      </div>
    </figure>
  ))
);
